<template>
  <router-link to="/">
    <img
      class="img-fluid"
      src="../../assets/images/logo/logo.png"
      width="160"
      alt=""
    />
  </router-link>
</template>
<script>

  export default {
    name: 'Logo',
  };
</script>
